module.exports = __webpack_public_path__ + "img/dwarf_17.02c852bb.png";